
// export const BASE_API_URL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api' : '';
export const BASE_API_URL = process.env.NODE_ENV === 'development' ? 'http://192.168.0.5:8000/api' : 'https://ramainternationally.com/api';

export const DEFAULT_EMAIL: string = "info@ramainternationally.com"

export const RECAPTCHA_PUBLIC_KEY: string = process.env.NODE_ENV === 'development' ? '6LeR3CkqAAAAAFVqXmT8amh8LVnr8JvHpZkWF6br' : '6Ldt-gEsAAAAAL_RenK7svzIF2TgfndyznWroFLG';

